import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $("#delete-api-credential-modal").on("show.bs.modal", function(e) {
      var data = $(e.relatedTarget).data()
      $(".user-name", this).text(data.user)
      $("form", this).attr("action", data.path)
    })

    $("form.edit_organization").submit(function() {
      $(this).find("input[type=\"submit\"]")
        .val("Deleting...")
        .attr("disabled", "disabled")

      $(this).find("a[data-dismiss]")
        .attr("disabled", "disabled")
        .click(function(e){ e.preventDefault(); return false })

      return true
    })
  }
}
